import React, { useEffect, useMemo, useState , useRef } from "react";
import ViewImage from './ViewImage';
import historyHandler from 'jd-library/historyHandler';
import SliderWrapper from 'jd-library/SliderWrapper';
import AnimateOnHover from 'jd-library/AnimateOnHover';
import styles from './viewImage.scss';
import { connect } from "react-redux";
import { getListingData, updateProductMediaLocal } from "../../actions/products";
import config from "../../../config/config";
import { showToastMessage } from "../../actions/toastmessage";

const getSliderWrapperProps = ({className, isMobile, handleSave, loader, isReadOnly, noOfSlidersOpen, type, props}) => {
	const headerPropsWeb = {
		heading: `${(type == 'product' || props?.categoryType == 'product') ? 'Product' : 'Service'} Image`,
		variant: 'secondary',
		leftIcons: []
	}
	if(noOfSlidersOpen < 1){
		headerPropsWeb.leftIcons = []
	} else{
		delete headerPropsWeb.leftIcons
	}
	const sliderWrapperProps = {
		web: {
			header: headerPropsWeb,
			slider: {
				slideDirection: 'right',
				disableAnimation: false,
				className: `${styles['view-image-slider']} ${className}`
			},
			footer: isReadOnly ? null : {
				btnProps: [{
					children: 'Save',
					showLoader: loader,
					onClick: handleSave
				}]
			}
		},
		mobile: {
			slider: {
				slideDirection: 'bottom',
				disableAnimation: true,
				className: `${styles['view-image-slider']} ${className}`
			},
			footer: isReadOnly ? null : {
				btnProps: [{
					children: 'Save',
					showLoader: loader,
					onClick: handleSave,
					className: props?.hasGlassFooter ? styles['ios-btn-cls'] : ''
				}]
			}
		}
	}
	return sliderWrapperProps[isMobile ? 'mobile' : 'web']
}

const ViewImageSlider = (props) => {
	const [loader, setLoader] = useState(false);
	const filesref = useRef(null);
	const [data, setData] = useState(() => ({
		imageUrlArr : props.imageUrlArr,
		videoUrlIds: props.videoUrlIds,
		undoInfo: null,
		videoUrlArr: props.videoUrlArr
	}));
	const [errorMsg, setErrorMsg] = useState('');
	useEffect(() => {
		if(filesref && filesref.current && data.imageUrlArr[data.imageUrlArr.length -1]?.noOfFilesToUpload === filesref.current.length){
			const dataimages = data.imageUrlArr.filter((l) => !l.toDelete);
			const lastimages = filesref.current;
			setData(() => ({...data, imageUrlArr: [...dataimages , ...lastimages] }));
			filesref.current = null;
		}
	},[data.imageUrlArr]);
	const closeSlider = ()=> {
		props.refreshListingData({
			tabKey: props.tabKey,
			isSearch: props.search?.results?.length,
			searchText: props.search?.results?.length ? props.search?.searchQuery : '',
			cb: (list) => {
				if(props.from === 'listing'){
					if(list){
						historyHandler.closeCurrent();
					}
				} else {
						props.closeCB && props.closeCB();
						historyHandler.closeCurrent();
					}
				}
			});
	}

	const UpdateData = (payload) => {
		setData(() => ({
			...data,
			undoInfo: payload.undoInfo,
			imageUrlArr: [...payload.imageUrlArr]
		}))
	}
	const onFileUpload = (payload) => {
		if(!payload.forVideo && !payload?.imageUrl?.imgURL && !payload.createdfrom){
			return;
		}
		if(payload.noOfFilesToUpload > 1 && !payload.forVideo){
			if(filesref.current){
				filesref.current.push(payload.imageUrl);
			} else {
				filesref.current = [payload.imageUrl];
			}
			setData(() => ({...data , imageUrlArr: [...data.imageUrlArr, { noOfFilesToUpload: payload.noOfFilesToUpload , toDelete: true }]}))
		} else {
			const values = updateProductMediaLocal(data,payload,(newpayload) => setData(() => newpayload));
			if(values){
				setData(() => values);
				return values;
			}
		}
	}
	const deleteProductVideo = () => {
		setData(() => ({...data, videoUrlIds: [] , videoUrlArr: []}));
	}
	const restoreProductData = () => {
		const index = data.undoInfo?.index;
		const imageUrlArr = [...data.imageUrlArr.slice(0, index) , data.undoInfo?.data , ...data.imageUrlArr.slice(index)];
		setData(() => ({ ...data , imageUrlArr }));
	}
	const uploadOptionProps = props.from === 'listing' ? {
		onFileUpload,
		fromViewImageSlider: true
	} : props.uploadOptionProps


	const handleSave = async () => {
		if(props.hideSaveButton){
			return props.onHidden();
		}
		if (props.session.img_required_flag && props.type == 'product' && data.imageUrlArr.length==0 && !props.session.viaOmni) {
			props.showNotify({
				showToastMessage: true,
				message: "Please Upload Product Image",
				type: 'error',
				duration: 5000,
				bottom: props.session.hasGlassFooter ? '80px' : '0px',
			});
			setErrorMsg('Please Upload Product Image');
			return false;
		} else {
			setErrorMsg('');
		}
		setLoader(() => true);
		const url = config.apiDomains[0] + '/marketplace/static/php/web/b2bWebsite.php';
		const  imageUrl = data.imageUrlArr?.map((l) => l.imgURL).join(',');
		const params = {
			action: 'addOrUpdateImage',
			productId: props.productId,
			token: props.session.token,
			sourceId: ''
		};
		if(props.session.viaOmni) {
			params.viaOmni = props.session.viaOmni;
		}
		const values = new FormData();
		values.append('imageUrl', imageUrl);
		values.append('videoUrl', '');
		try {
			const { default: { post, get } } = await import('axios');
			const apiRsp = await post(url, values , { params });
			let tMsg = "Images and Videos are Updated Successfully"
			if(apiRsp.data.status == 0){
				tMsg = apiRsp.data?.msg || "Something went wrong"
			}else{
				props.updateScrollPos(1);
				window.ignoreScrollRetain = true;
			}
			params.action = 'linkUnlinkProductVideo';
			params.videoIdList = data.videoUrlIds?.length ? data.videoUrlIds[0] : '';
			await get(url, { params });
			props.showNotify({
				showToastMessage: true,
				message: tMsg,
				type: 'info',
				duration: 5000,
				bottom: props.session.hasGlassFooter ? '80px' : '0px',
			});
			closeSlider();
		} catch (error) {
			console.error(error?.message || error);
			props.showNotify({
				showToastMessage: true,
				message: 'Server error please try again!.',
				type: 'error',
				duration: 5000,
				bottom: props.session.hasGlassFooter ? '80px' : '0px',
			});
		} finally {
			setLoader(() => false);
		}
	}
	const noOfSlidersOpen = useMemo(() => historyHandler.getOpenSliders().length, []);
	const isReadOnly = (props.session.isReadOnly || props.isBrandedProduct);
	useEffect(() => {
		const prevScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
		if(props.isMobile && props.productListViewImageSlider) {
			document.body.classList.add('handle-listing-scroll');
		}
		return () => {
			document.body.classList.remove('handle-listing-scroll');
			props.productListViewImageSlider && window.scrollTo(0, window?.ignoreScrollRetain ? 1 : prevScrollTop);
		}
	}, [])
	return (
		<SliderWrapper
			{...props}
			{...getSliderWrapperProps({className:props.className, isMobile:props.isMobile, handleSave, loader, isReadOnly, noOfSlidersOpen, type: props.type, profileObject: props.session?.profileObject})}
			onHidden={() => {
				if(!loader){
					props.refreshListingData({
						tabKey: props.tabKey,
						cb: () => {
							props.onHidden();
						}
					});
				}
			}}
		>
			<div className={`${styles['view-image-slider']} ${styles[props.className]}`}>
				{props.isMobile ? 
				<div className="anim-header">
					<AnimateOnHover className={styles['back-btn']} onClick={closeSlider}>
						<i className={`${styles['image-icon']} icon-HDRback`}/>
					</AnimateOnHover>
						<div className="image-slider-heading">{`${(props.type == 'product' || props.categoryType == 'product') ? 'Product' : 'Service'} Image`}</div>
				</div>
				 : null}
				<ViewImage
					closeSlider={closeSlider}
					{...props}
					errorMessage={errorMsg}
					imageUrlArr={props.from === 'listing' ? data.imageUrlArr : props.imageUrlArr}
					videoUrlIds={props.from === 'listing' ? data.videoUrlIds : props.videoUrlIds}
					videoUrlArr={props.from === 'listing' ? data.videoUrlArr : props.videoUrlArr}
					updateProductImage={props.from === 'listing' ? UpdateData : props.updateProductImage}
					deleteProductImage={props.from === 'listing' ? UpdateData : props.deleteProductImage}
					deleteProductVideo={props.from === 'listing' ? deleteProductVideo : props.deleteProductVideo}
					restoreProductData={props.from === 'listing' ? restoreProductData : props.restoreProductData}
					hideAddVideo={props.from === 'listing' ? Boolean(props.showUpload) : false}
					ignoreSave={true}
					uploadOptionProps={uploadOptionProps}
					noImgLabel = {props.noImgLabel ? props.noImgLabel : (props.type=='service' ? "Add a Service Photo" : "Add a Product Photo")}
				/>
			</div>
		</SliderWrapper>

	)
};

const getVideoById = (id, videos = {}) => {
	let videoObj;
	if (videos[id]) {
		videoObj = videos[id]
	} else {
		id = Object.keys(videos).find(key => videos[key].imgIndex === id)
		videoObj = videos[id]
	}
	return videoObj
}

 const getVideoUrlArr = (videoUrlIds, {
	videoLibrary
}) => {
	const {
		videos
	} = videoLibrary;
	const videoUrlArr = []
	if (!videoUrlIds) {
		return []
	}
	videoUrlIds.forEach((curId) => {
		let curVideoData = getVideoById(curId, videos);
		if (curVideoData) {
			curVideoData = { ...curVideoData };
			curVideoData.videoId = curId;
			videoUrlArr.push(curVideoData)
		}
	})
	return videoUrlArr;
}

const mapStateToProps = (state,props) => {
	return {
		...props,
		isMobile : state.library.deviceData.isMobile,
		session:state.session,
		tabKey:state.products.tabKey,
		allProductsData: state.products.allProducts[props.productId] || {},
		showUpload: state.products?.allProducts?.[props.productId]?.showUpload,
		imageUrlArr: props.imageUrlArr || state.products.allProducts[props.productId]?.imageUrlArr || [],
		videoUrlIds: state.products.allProducts[props.productId]?.videoUrlIds || [],
		videoUrlArr: props.videoUrlIds ? getVideoUrlArr(props.videoUrlIds, state) : getVideoUrlArr(state.products.allProducts[props.productId]?.videoUrlIds , state),
		search: state.products.search,
		hasGlassFooter: state?.session?.hasGlassFooter
	}
}

const mapDispatchToProps = (dispatch) => ({
	refreshListingData: (payload) => dispatch(getListingData({...payload,fromImageSlider: true})),
	showNotify:(payload) => dispatch(showToastMessage(payload))
})

export default connect(mapStateToProps,mapDispatchToProps,null,{forwardRef:true})(ViewImageSlider);
